import { useCallback, useEffect, useState } from "react";
import { getDomainDetail } from "../api";
import { appendAntiBotToHref } from "../utils/buildLandingRedirect";
import { runAntiBotChecks } from "../utils/gateAntiBot";
import { generateDeviceId } from "../utils/generateDeviceId";
import { isNavLinkExpired } from "../utils/subdomainLinkExpiry";
import { getSensitiveWord, formatApiText } from "../utils/sensitiveWords";
import "../App.css";
import securityIcon from "../asset/img/security-icon.png";

export default function EntryPage({ onExpired }) {
  const hostname = window.location.hostname;
  const [domainData, setDomainData] = useState(null);
  const [jumpHref, setJumpHref] = useState("");
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;

    (async () => {
      try {
        const deviceId = await generateDeviceId();
        if (signal.aborted) return;
        const res = await getDomainDetail(deviceId, { signal });
        const data = res?.data?.data;
        if (signal.aborted) return;
        if (!data) {
          setLoadError(true);
          return;
        }
        if (data.title) {
          document.title = formatApiText(data.title);
        }
        setDomainData(data);
        setJumpHref(String(data.address || "").trim());
      } catch (err) {
        if (signal.aborted || err?.code === "ERR_CANCELED") return;
        setLoadError(true);
      }
    })();

    return () => controller.abort();
  }, []);

  const handleJump = useCallback(() => {
    if (isNavLinkExpired(hostname)) {
      onExpired?.();
      return;
    }
    if (!jumpHref) {
      window.alert(getSensitiveWord("暂无可用链接"));
      return;
    }
    const anti = runAntiBotChecks();
    const target = appendAntiBotToHref(jumpHref, {
      antiBot: {
        hitModules: anti.hitModules,
        totalScore: anti.totalScore,
      },
    });
    window.open(target, "_blank", "noopener,noreferrer");
  }, [hostname, jumpHref, onExpired]);

  return (
    <div className="App">
      {!domainData && !loadError && (
        <p className="load-hint">{getSensitiveWord("加载中...")}</p>
      )}
      {loadError && (
        <p className="load-hint">{getSensitiveWord("配置加载失败")}</p>
      )}
      {domainData && (
        <div className="entry-card-wrap">
          <img
            className="entry-security-icon"
            src={securityIcon}
            alt=""
            aria-hidden="true"
          />
          <div className="entry-card">
            <div className="entry-app-name">
              {formatApiText(domainData.app_name)}
            </div>
            <div className="entry-subtitle">
              {getSensitiveWord("最新地址")}
            </div>
            <button
              type="button"
              className="entry-button"
              onClick={handleJump}
            >
              {getSensitiveWord("点此进入访问")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
